import { Role } from '../../../shared/enum';
import { getRoleLabel } from '../utils';

type RoleLabelProps = {
  role: Role;
};

export const RoleLabel = ({ role }: RoleLabelProps) => (
  <>{getRoleLabel(role)}</>
);
